<template>
  <vx-card no-shadow>

    <!--vs-input class="w-full mb-base" label-placeholder="Old Password" v-model="old_password" />
    <vs-input class="w-full mb-base" label-placeholder="New Password" v-model="new_password" v-validate="'required|min:6|max:10'" />
    <vs-input class="w-full mb-base" label-placeholder="Confirm Password" v-model="confirm_new_password" v-validate="new_password==confirm_new_password"/-->
    <vs-input v-model="old_password" label-placeholder="Old Password" name="password" icon-no-border icon="icon icon-lock" icon-pack="feather" v-validate="'required|min:6|max:10'" type="password"  class="w-full mt-6" />
      <span class="text-danger text-sm">{{ errors.first('password') }}</span>  
    <vs-input  v-model="new_password" label-placeholder="New Password" ref="password" name="password1" icon-no-border icon="icon icon-lock" icon-pack="feather" v-validate="'required|min:6|max:10'" type="password"   class="w-full mt-6" />
      <span class="text-danger text-sm">{{ errors.first('password1') }}</span>
    <vs-input  v-model="confirm_new_password" label-placeholder="Confirm Password" name="password2" icon-no-border icon="icon icon-lock" icon-pack="feather" v-validate="'required|confirmed:password'"  type="password"  class="w-full mt-6" />
      <span class="text-danger text-sm">{{ errors.first('password2') }}</span>
    <form id="demo">

    <!-- INPUTS 
    <div class="input-group">
      <h4 id="header"> Enter Password</h4>

      <div class="input-fields">
        <input v-validate="'required'" name="password" type="password" placeholder="Password" ref="password">

        <input v-validate="'required|confirmed:password'" name="password_confirmation" type="password" placeholder="Password, Again" data-vv-as="password">
      </div>
    </div>-->

    <!-- ERRORS 
    <div class="alert alert-danger" v-show="errors.any()">
      <div v-if="errors.has('password')">
        {{ errors.first('password') }}
      </div>
      <div v-if="errors.has('password_confirmation')">
        {{ errors.first('password_confirmation') }}
      </div>
    </div>-->

  </form>  
    <!-- Save & Reset Button :disabled="!validateForm"-->
    <div class="flex flex-wrap items-center justify-end mt-3">
      <vs-button  class="ml-auto mt-2" :disabled="!validateForm" @click="save_changes">Save Changes</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Reset</vs-button>
    </div>
  </vx-card>
</template>

<script>
import axios from "../../../http/axios/index.js"
export default {
  data() {
    return {
      id: this.$store.state.AppActiveUser.id,
      name: this.$store.state.AppActiveUser.nom,
      email: this.$store.state.AppActiveUser.email,
      old_password: "",
      new_password: "",
      confirm_new_password: "",
    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
    validateForm() {
      return !this.errors.any() && this.old_password  != '' && this.new_password != '' && this.confirm_new_password != '' && this.confirm_new_password == this.new_password;
    },
    
  },
  
  methods: {
    
    save_changes() {
      axios.post("https://trainingcenterback.codily.net/api/change_password_Candidat/"+this.id, {
        
        old_password: this.old_password,
        new_password: this.new_password,

      } ).then((response) => {
          console.log("admins",response.data)
          if(response.data=="false_password"){
            this.showMessage('danger', 'update', 'Faux mot de passe') 
          }else{
            this.$store.dispatch('auth/updateauth', response.data)
            this.showMessage('success', 'update', 'successfully update')
          }
          
        })
      
      
     
    },
    showMessage(color, title, text) {
              this.$vs.notify({
                color: color,
                title: 'compte '+title,
                text: 'The compte was '+text
              })
            },
    reset_data() {
     this.old_password = "";
     this.new_password = "";
     this.confirm_new_password = "";
    },
    update_avatar() {
      // You can update avatar Here
      // For reference you can check dataList example
      // We haven't integrated it here, because data isn't saved in DB
    }
  },
}
</script>
